import { EssayProtocolAir } from './essayProtocolAir';
import { FilterAir } from './filterAir';

export class ExecutionEssayDialogResponse {
    essay: EssayProtocolAir;
    filters: FilterAir[];

}
